import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import limitDetails from './components/limitDetails';
import batchEmail from './components/batchEmail';
import addEmail from "./components/add.vue";
import viewArticles from "./components/viewArticles.vue";
import contentView from "./components/contentView.vue";
import idDetails from "./components/idDetails.vue";
import addEmailcopy from './components/addEmailcopy.vue';
import { mailList, mailListNew, sendMailnew, delEmailsNew, userChannelList } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
export default {
  name: "email",
  components: {
    addEmail: addEmail,
    viewArticles: viewArticles,
    contentView: contentView,
    idDetails: idDetails,
    batchEmail: batchEmail,
    limitDetails: limitDetails,
    addEmailcopy: addEmailcopy
  },
  mixins: [gmTool],
  data: function data() {
    return {
      advanced: false,
      tableData: [],
      // 表格数据
      total: 0,
      tableCopyTableList: [],
      // 表格copy数据
      value1: '',
      paramsData: {
        // is_default: '',
        // language: '',
        page: 1
      },
      listB: [],
      TopLevelNot: true,
      channelList: []
    };
  },
  created: function created() {
    this.pageFn = this.getList;
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getserverList();

            case 2:
              _this.getList(1);

              _this.getChannel();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    getChannel: function getChannel() {
      var _this2 = this;

      userChannelList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.channelList = res.data;
        }
      });
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getserverList();

              case 2:
                _this3.getList(1);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    regeneration: function regeneration(row) {
      var data = JSON.parse(JSON.stringify(row));
      data.id = '';
      this.$refs.sendEmail.open(data);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this4 = this;

      this.sels = [];
      val.forEach(function (e) {
        if (_this4.tableData.findIndex(function (i) {
          return i.id == e.id;
        }) > -1) {
          _this4.sels.push(e.id);
        }
      });
      this.selsString = this.sels.toString();
    },
    sendEmails: function sendEmails(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmSendEmail'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var loading;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading = _this5.$loading({
                  lock: true,
                  text: _this5.$t('sending'),
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                sendMailnew({
                  id: id,
                  is_prod: _this5.paramsData.is_prod,
                  game_id: _this5.rawData.game_id
                }).then(function (res) {
                  loading.close();

                  if (res.status == 200) {
                    _this5.getList(_this5.paramsData.page);

                    _this5.$message({
                      type: "success",
                      message: _this5.$t('sendSuccess')
                    });
                  }
                }).finally(function () {
                  loading.close();
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    getList: function getList(e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var objToTitle, objToKey;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.reqLoading = true;
                _this6.paramsData.page = e;

                objToTitle = function objToTitle(obj) {
                  return Object.keys(obj).map(function (k) {
                    return obj[k];
                  });
                };

                objToKey = function objToKey(obj) {
                  return Object.keys(obj).map(function (k) {
                    return k;
                  });
                };

                mailListNew(_this6.paramsData).then(function (res) {
                  if (res.status == 200) {
                    if (!res.data.result.length && _this6.paramsData.page > 1) {
                      _this6.getList(_this6.paramsData.page - 1);
                    } else {
                      res.data.result.map(function (item) {
                        item.created_at = _this6.$times.formDate(item.created_at, 8);
                        item.server_name = '';
                        item.server_ids.forEach(function (element) {
                          var idIndex = _this6.serverLists.findIndex(function (i) {
                            return i.serverID == element;
                          });

                          item.server_name += idIndex > -1 ? "".concat(_this6.serverLists[idIndex].serverName, ",") : "".concat(element, ",");
                        });

                        if (Array.isArray(item.request_data)) {
                          item.content_Val = !item.request_data ? [] : item.request_data[0].title_content;
                        } else {
                          item.content_Val = item.request_data ? item.request_data.title_content : [];
                        } // if (item.is_list_role == 1) {
                        //   let list = []
                        //   for (let key in item.reward) {
                        //     item.reward[key].forEach((k) => {
                        //       list.push({
                        //         role_id: key,
                        //         ...k,
                        //         // expire: this.$times.timestampToTime(k.expire, 'YY-MM-DD h')
                        //       })
                        //     })
                        //   }
                        //   // let reward = objToTitle(item.reward)
                        //   // reward.map(i=>{
                        //   //   i.map(j=>{
                        //   //     j.expire = this.$times.timestampToTime(j.expire,'YY-MM-DD h')
                        //   //   })
                        //   // })
                        //   let args = objToKey(item.args)
                        //   item.reward = list
                        //   item.args = args
                        // }


                        item.args = Array.from(new Set(item.args));
                      });
                      _this6.tableData = res.data.result;
                      _this6.total = res.data.total;
                    }
                  }
                }).finally(function () {
                  _this6.reqLoading = false;
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this7 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then(function () {
        delEmailsNew(_objectSpread({
          ids: id
        }, _this7.paramsData)).then(function (res) {
          if (res.status == 200) {
            _this7.getList(_this7.paramsData.page);

            _this7.$message({
              type: "success",
              message: _this7.$t('deleteSuccess')
            });
          }
        });
      });
    }
  }
};